import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ScrollPanelModule } from 'primeng/scrollpanel';

import { Error403Component } from './global-error-components';
import { MaterialModule } from '../core/_material/_material.module';
import { ShareService } from './service/share-service.service';
import { ShareServiceMessage } from './service/share-service-message.service';
// gen_imports


/**
 *  Modulo donde se puede realizar instanciación modular de clases
 */
@NgModule({
  imports: [CommonModule, RouterModule, HttpClientModule, MaterialModule],
  declarations: [
    Error403Component
// gen_declarations

  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ScrollPanelModule,
    Error403Component,
    MaterialModule
// gen_exports

  ], 
  providers: [ ShareService , ShareServiceMessage ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule
    };
  }
}
